import { useCallback, useEffect, useRef } from "react";

const FIT_MIN_WIDTH = 68;

export function fitPgGridColumns(api) {
  if (!api) {
    return;
  }
  window.requestAnimationFrame(() => {
    try {
      api.sizeColumnsToFit({ defaultMinWidth: FIT_MIN_WIDTH });
    } catch {
      /* grid not ready */
    }
  });
}

/** Keeps AG Grid columns within the panel width on resize, pagination, and data changes. */
export function usePgGridColumnFit(rowData) {
  const apiRef = useRef(null);

  const fitColumns = useCallback(() => {
    fitPgGridColumns(apiRef.current);
  }, []);

  useEffect(() => {
    fitColumns();
  }, [rowData, fitColumns]);

  useEffect(() => {
    window.addEventListener("resize", fitColumns);
    return () => window.removeEventListener("resize", fitColumns);
  }, [fitColumns]);

  return {
    onGridReady: (params) => {
      apiRef.current = params.api;
      fitColumns();
    },
    onFirstDataRendered: fitColumns,
    onGridSizeChanged: fitColumns,
  };
}
